<template>
	<div class="chat-system-box">
		<el-container>
			<el-header height="50px">
				<span class="h5-back" title="返回" @click.stop="onH5Back"><i class="el-icon-arrow-left"></i></span>
				<span>{{ chat.showName }}</span>
			</el-header>
			<el-main class="chat-main" id="chatScrollBox" @scroll="onScroll">
				<div v-for="(msgInfo, idx) in showMessages" :key="msgInfo.id || msgInfo.seqNo || (showMinIdx + idx)">
					<div class="message-box" @click="onClickMessage(msgInfo)"
						v-if="msgInfo.type == $enums.MESSAGE_TYPE.SYSTEM_MESSAGE">
						<div class="title">{{ msgInfo.title }}</div>
						<img class="cover" v-show="msgInfo.coverUrl" :src="$mediaUrl(msgInfo.coverUrl)" />
						<div class="intro">{{ msgInfo.intro }}</div>
						<div class="bottom-bar">查看详情</div>
					</div>
					<div class="chat-msg-tip" v-if="msgInfo.type == $enums.MESSAGE_TYPE.TIP_TIME">
						{{ $date.toTimeText(msgInfo.sendTime) }}
					</div>
				</div>
			</el-main>
			<chat-system-content ref="contentRef"></chat-system-content>
		</el-container>
	</div>
</template>

<script>
import ChatSystemContent from './ChatSystemContent';
import { filterMessagesByRetention } from '@/utils/chatRetention';

export default {
	name: "chatSystem",
	components: { ChatSystemContent },
	props: {
		chat: {
			type: Object
		}
	},
	data() {
		return {
			showMinIdx: 5
		}
	},
	computed: {
		retentionDays() {
			return 0;
		},
		retainedMessages() {
			return filterMessagesByRetention((this.chat && this.chat.messages) || [], this.retentionDays);
		},
		showMessages() {
			return this.retainedMessages.slice(this.showMinIdx);
		}
	},
	methods: {
		onClickMessage(msgInfo) {
			this.$refs.contentRef.show(msgInfo.id, msgInfo.title);
		},
		onH5Back() {
			this.$store.dispatch("activateChat", -1);
		},
		readedMessage() {
			if (this.chat.unreadCount == 0) {
				return;
			}
			let maxSeqNo = this.$store.state.chatStore.systemMsgMaxSeqNo;
			let url = `/message/system/readed?maxSeqNo=${maxSeqNo}`
			this.$http({
				url: url,
				method: 'put'
			})
		},
		scrollToBottom() {
			this.$nextTick(() => {
				let div = document.getElementById("chatScrollBox");
				div.scrollTop = div.scrollHeight;
			});
		},
		onScroll(e) {
			let scrollElement = e.target
			let scrollTop = scrollElement.scrollTop
			if (scrollTop < 30) { // 在顶部,不滚动的情况
				if (this.showMinIdx > 0) {
					this.showMinIdx = this.showMinIdx > 5 ? this.showMinIdx - 5 : 0;
				} else if (this.chat && this.chat.messagesTrimmed) {
					const prevVisible = this.retainedMessages.length;
					this.$store.dispatch("loadOlderChatMessages", this.chat).then((added) => {
						const visibleAdded = Math.max(0, this.retainedMessages.length - prevVisible);
						if (visibleAdded) {
							this.showMinIdx += visibleAdded;
						}
					});
				}
			}

		},
	},
	watch: {
		chat: {
			handler(newChat, oldChat) {
				if (!this.chat) {
					return;
				}
				const setup = () => {
					this.readedMessage();
					this.scrollToBottom();
					let size = this.retainedMessages.length;
					this.showMinIdx = size > 5 ? size - 5 : 0;
				};
				if (this.chat.messagesTrimmed && !this.chat.messagesHydrated) {
					this.$store.dispatch("hydrateChatMessages", this.chat).then(setup);
				} else {
					setup();
				}
			},
			immediate: true
		}
	},
	mounted() {
		let div = document.getElementById("chatScrollBox");
		div.addEventListener('scroll', this.onScroll)
	}
}
</script>

<style lang="scss" scoped>
.chat-system-box {
	display: flex;
	flex-direction: column;
	position: relative;
	width: 100%;
	background: #f8f8f8;

	.chat-main {
		background: #F8F8F8;
		margin: 0 3px;
		display: flex;
		flex-direction: column;
		align-items: center;

		.message-box {
			width: 400px;
			background-color: white;
			text-align: left;
			border-radius: 3%;
			margin: 15px;
			padding: 5px 20px;
			cursor: pointer;

			.title {
				text-align: center;
				font-size: 18px;
				white-space: nowrap;
				overflow: hidden;
				margin: 10px 20px;
				font-weight: 600;
			}

			.cover {
				width: 100%;
				height: 200px;
				object-fit: cover;
			}

			.intro {
				padding: 8px;
				font-size: 16px;
				border-bottom: 1px #eee solid;
				overflow-wrap: break-word
			}

			.bottom-bar {
				font-size: 14px;
				padding: 8px;
				text-align: left;
				color: blue;
			}
		}

		.chat-msg-tip {
			line-height: 20px;
			font-size: var(--im-font-size-small);
			color: var(--im-text-color-light);
		}
	}
}
</style>